/**
 * Simple console logger with different log levels
 * In production, logs can be sent to a service like Sentry or LogRocket
 */

type LogLevel = 'debug' | 'info' | 'warn' | 'error';

const LOG_LEVEL: LogLevel = (import.meta.env.VITE_LOG_LEVEL as LogLevel) || 'info';

const LOG_LEVELS: Record<LogLevel, number> = {
  debug: 0,
  info: 1,
  warn: 2,
  error: 3,
};

function shouldLog(level: LogLevel): boolean {
  return LOG_LEVELS[level] >= LOG_LEVELS[LOG_LEVEL];
}

export const logger = {
  debug: (message: string, meta?: Record<string, any>) => {
    if (shouldLog('debug')) {
      console.debug(`[DEBUG] ${message}`, meta || '');
    }
  },

  info: (message: string, meta?: Record<string, any>) => {
    if (shouldLog('info')) {
      console.info(`[INFO] ${message}`, meta || '');
    }
  },

  warn: (message: string, meta?: Record<string, any>) => {
    if (shouldLog('warn')) {
      console.warn(`[WARN] ${message}`, meta || '');
    }
  },

  error: (message: string, meta?: Record<string, any>) => {
    if (shouldLog('error')) {
      console.error(`[ERROR] ${message}`, meta || '');
    }
  },
};
